import { render, staticRenderFns } from "./TicketFeedbackComments.vue?vue&type=template&id=48a34272&"
import script from "./TicketFeedbackComments.vue?vue&type=script&lang=ts&"
export * from "./TicketFeedbackComments.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports